// React
import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';

class DialogUrlParams extends React.PureComponent {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        close: PropTypes.func,
        open: PropTypes.bool,
        params: PropTypes.object,
        fullScreen: PropTypes.bool,
    };

    handleChangeUrl = event => {
        this.setState({ url: event.target.value });
    };

    formatConfig = config => {
        let value = '';

        config.forEach(element => {
            if (value) {
                value = value + ' | ' + element.key + ' : ' + element.value;
            } else {
                value = element.key + ' : ' + element.value;
            }
        });

        return value;
    };

    render() {
        const { fullScreen, classes, params, open, close } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
            >
                <DialogTitle id='responsive-dialog-title'>URL params</DialogTitle>
                <DialogContent>
                    {params && params.add ?
                        <div>
                            <p className={classes.separator}>{'--------------------------------------------------'}</p>
                            <p className={classes.text}>{'Type : BW_ADD'}</p>
                            <p className={classes.text} style={{ whiteSpace: 'pre-line' }}>{'Params : ' + params.add}</p>
                        </div>
                        :
                        null
                    }
                    {params && params.mul ?
                        <div>
                            <p className={classes.separator}>{'--------------------------------------------------'}</p>
                            <p className={classes.text}>{'Type : BW_MUL'}</p>
                            <p className={classes.text} style={{ whiteSpace: 'pre-line' }}>{'Params : ' + params.mul}</p>
                        </div>
                        :
                        null
                    }
                    {params && params.reference ?

                        <div>
                            <p className={classes.separator}>{'--------------------------------------------------'}</p>
                            <p className={classes.text}>{'Type : BW_REF'}</p>
                            <p className={classes.text} style={{ whiteSpace: 'pre-line' }}>{'Params : ' + params.reference}</p>
                        </div>
                        :
                        null
                    }
                    {params && params.config && params.config.length > 0 ?
                        <div>
                            <p className={classes.separator}>{'--------------------------------------------------'}</p>
                            <p className={classes.text}>{'Type : BW_CONFIG'}</p>
                            <p className={classes.text} style={{ whiteSpace: 'pre-line' }}>{'Params: ' + this.formatConfig(params.config)}</p>
                        </div>
                        :
                        null
                    }
                    <p className={classes.separator}>{'--------------------------------------------------'}</p>
                </DialogContent>
                <DialogActions>
                    <IconButton color='primary' onClick={() => {
                        close();
                    }}>
                        <DoneIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    separator: {
        marginTop: '0'
    },
    text: {
        fontFamily: 'roboto'
    }
});

export default withStyles(styles)(DialogUrlParams);
